import Services from "../../../services"

class KegiatanAnggaranApi {
  getRealisasi(page, dataLength) {
    return Services.get(`/ang/kegiatan/page/?page=${page}&per_page=${dataLength}&kode_status=APP&is_close=true`)
  }

  getListKegiatanRealisasi(page, dataLength) {
    return Services.get(`/ang/kegiatan/page/?page=${page}&per_page=${dataLength}&kode_status=APP&is_close=false`)
  }
  
  getKegiatanRealisasi(id) {
    return Services.get("/ang/kegiatan_realisasi/form?id_kegiatan=" + id);
  }

  getNomorRealisasi(value) {
    return Services.get("/ang/kegiatan_realisasi/no_baru?tanggal=" + value)
  }

  changeStatusOpen(value) {
    return Services.put("/ang/kegiatan/open", value)
  }

  changeStatusClose(value) {
    return Services.put("/ang/kegiatan/close", value)
  }

  createKegiatanRealisasi(value) {
    return Services.post("/ang/kegiatan_realisasi", value)
  }

  updateRealisasiWaktu(value) {
    return Services.post("/ang/kegiatan_realisasi/waktu", value)
  }

  uploadBukti(value) {
    return Services.post("/ang/upload/bukti", value)
  }

  deleteKegiatanSumberDayaRealisasi(id) {
    return Services.post("/ang/kegiatan_realisasi/delete", id)
  }
}

export default new KegiatanAnggaranApi()
